class FreeShippingNotice extends HTMLElement {
  connectedCallback() {
    this.threshold = parseInt(this.dataset.threshold, 10);
    this.messageEl = this.querySelector('[data-fs-message]');
    this.iconWrapper = this.querySelector('[data-fs-icon]');

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.refresh();
    });

    this.observeCartDrawerClose();

    this.refresh();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    if (this.drawerObserver) this.drawerObserver.disconnect();
  }

  // Watches the cart-drawer's `active` class — when it transitions from active
  // to inactive (drawer just closed), refresh the free shipping state. Acts as
  // a safety net in case a cart change happened without firing cartUpdate.
  observeCartDrawerClose() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    let wasActive = drawer.classList.contains('active');
    this.drawerObserver = new MutationObserver(() => {
      const isActive = drawer.classList.contains('active');
      if (wasActive && !isActive) this.refresh();
      wasActive = isActive;
    });
    this.drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  async refresh() {
    try {
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      const res = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      this.render(cart.total_price);
    } catch (err) {
      console.error('[free-shipping-notice]', err);
    }
  }

  render(totalCents) {
    const remaining = this.threshold - totalCents;
    const reached = remaining <= 0;

    this.classList.toggle('free_shipping--reached', reached);

    if (reached) {
      this.messageEl.innerHTML = 'Livraison <strong>offerte</strong>&nbsp;!';
      if (this.iconWrapper) this.iconWrapper.innerHTML = FreeShippingNotice.ICON_CHECK;
    } else {
      const formatted = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
      }).format(remaining / 100);
      this.messageEl.innerHTML = `Plus que <strong>${formatted}</strong> pour la livraison gratuite`;
      if (this.iconWrapper) this.iconWrapper.innerHTML = '';
    }
  }
}

FreeShippingNotice.ICON_CHECK =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>';

customElements.define('free-shipping-notice', FreeShippingNotice);
